import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import './plugins'
import { store } from './store/store'
import './registerServiceWorker'
import VueGtag from 'vue-gtag'
require('es6-promise').polyfill()
require('isomorphic-fetch')

Vue.config.productionTip = false

Vue.use(VueGtag, {
  config: { id: 'UA-126207023-2' },
})

new Vue({
  router,
  vuetify,
  store,
  render: h => h(App),
}).$mount('#app')
